import React, { Component } from "react";
import { Alert, Row, Col, Button, Spin, Table, Divider, Tag, Space } from 'antd';
import { Spinner } from 'reactstrap';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import axios from '../../utils/request';
import 'antd/dist/antd.css';
import './EmploymentApproval.css'

export class employeapply extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            loading: true,
            code: "",
            tenantId: - 1,
            selectedRowKeys: [''],
            jobId: "",
            allSubmitsionData: {},
            btnloading: false,
            htmlString: "",
        }
    };

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        this.setState({ commonParamater: commonParamater, tenantId: tenantId });
        const params = {
            tenantId,
            commonParamater
        }
        axios
            .get("/api/HaoWeiLai/Index", { params: params })
            .then(res => {
                const data = res.data.data;
                console.log(data);
                this.setState({ allSubmitsionData: data, loading: false, code: res.data.code, message: res.data.message });
                this.selectedRowKeys();
            }).catch(reason => {
                const errorMessages = reason?.response?.data?.errorMessages ?? ["获取初始信息失败。"]
                this.setState({ errorMessage: errorMessages });
                this.setState({ loading: false });
            })
    };

    submitFun = () => {
        console.log(this.state.selectedRowKeys);
        //return;
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        const submissionId = this.state.selectedRowKeys[0];
        
        window.location.href = `/api/HaoWeiLai/PushData?tenantId=${tenantId}&commonParamater=${commonParamater}&submissionId=${submissionId}`
    };
    //默认选中
    selectedRowKeys = () => {
        const data = this.state.allSubmitsionData;
        for (var i = 0; i < data.length; i++) {
            let dataItem = data[i];
            console.log(dataItem);
            if (dataItem.isEffective === "是") {
                this.setState({
                    selectedRowKeys: [dataItem.submissionId]
                });
                console.log(this.state.selectedRowKeys);
                return;
            }
        };
    };
    //修改选择
    checkChange = (selectedRowKeys, selectedRows) => {
        console.log('keys:', selectedRowKeys, 'selectedRowKeys:', selectedRows)
        this.setState({
            selectedRowKeys: selectedRowKeys
        });
    }

    renderApplicantHtml = () => {
        const { selectedRowKeys } = this.state
        const { btnloading } = this.state
        const columns = [
            {
                title: '渠道类型',
                dataIndex: 'channelTypeText',
                key: 'channelTypeText',
            },
            {
                title: '渠道名称',
                dataIndex: 'channelName',
                key: 'channelName',
            },
            {
                title: '投递时间',
                key: 'deliverTime',
                dataIndex: 'deliverTime',
                key: 'deliverTime',
            },
            {
                title: '有效投递',
                key: 'isEffective',
                render: (_, record) => (
                    <Space size="middle">
                        <Tag color="lime">{record.isEffective}</Tag>
                    </Space>
                ),
            },
        ];
        return (
            <div class="mengniu">
                <h3>确认有效渠道</h3>
                <hr />
                <Table
                    columns={columns}
                    dataSource={this.state.allSubmitsionData}
                    //style={{ width: '90%', margin: 20 }}
                    rowKey={record => record.submissionId}
                    pagination={{ pageSize: 4 }}
                    rowSelection={{
                        columnTitle: "请选择",
                        onChange: this.checkChange,
                        type: 'radio',
                        selectedRowKeys: selectedRowKeys
                    }}
                />
                <div class="btn">
                    <Button type="primary" onClick={this.submitFun} loading={btnloading}>确认发起录用</Button>
                </div>
            </div>
        );
    };

    render() {
        let contents = "";

        if (this.state.loading) {
            contents = ""
            contents = <div style={{ height: '400px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Spin spinning={this.state.loading} size='large' />
            </div>
        } else {
            contents = ""
            if (this.state.code === "200") {
                //contents = <div>{this.state.message}</div>
                contents = this.renderApplicantHtml()
                if (this.state.htmlString !== "") {
                    console.log(this.state.htmlString);
                    //var html = `<!DOCTYPE html><html lang="zh-CN"><head><meta charset="UTF-8"><meta http-equiv="X-UA-Compatible"content="IE=edge,chrome=1"/><meta name="viewport"content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no"/><meta name="renderer"content="webkit"/><title>录用流程-好未来</title><script>var HOST='http://hr-api-t4.hr.chengjiukehu.com';</script><script type="text/javascript"src="http://hr-t4.hr.chengjiukehu.com/node_modules/bpit.common.data/dist/bpit.common.data.b.js"></script><script type="text/javascript">window.bpit_elk_page_start_time=(new Date()).getTime();</script><link rel="stylesheet"href="http://hr-t4.hr.chengjiukehu.com/assets/css/lib/bootstrap.min.css"><link rel="stylesheet"href="http://hr-t4.hr.chengjiukehu.com/assets/css/noticeMessage.css"><link rel="stylesheet"href="http://hr-t4.hr.chengjiukehu.com/assets/css/lib/bootstrap-datepicker.min.css"><link rel="stylesheet"href="http://hr-t4.hr.chengjiukehu.com/assets/lib/element-ui/lib/theme-chalk/index.css"><link rel="stylesheet"href="http://hr-t4.hr.chengjiukehu.com/assets/css/common.css"><script src="http://hr-t4.hr.chengjiukehu.com/assets/lib/sentry/bundle.min.js"integrity="sha384-KMv6bBTABABhv0NI+rVWly6PIRvdippFEgjpKyxUcpEmDWZTkDOiueL5xW+cztZZ"crossorigin="anonymous"></script><script type="text/javascript"src="http://hr-t4.hr.chengjiukehu.com/assets/js/lib/jquery-3.1.0.min.js"></script><script type="text/javascript"src="http://hr-t4.hr.chengjiukehu.com/assets/js/lib/jquery.warningModal.js"></script><script type="text/javascript"src="http://hr-t4.hr.chengjiukehu.com/assets/js/lib/bootstrap.min.js"></script><script type="text/javascript"src="http://hr-t4.hr.chengjiukehu.com/assets/js/lib/bootstrap-datepicker.min.js"></script><script type="text/javascript"src="http://hr-t4.hr.chengjiukehu.com/assets/js/lib/vue.min.js"></script><script src="http://hr-t4.hr.chengjiukehu.com/assets/lib/element-ui/lib/theme-chalk/index.js"></script><script type="text/javascript"src="http://hr-t4.hr.chengjiukehu.com/assets/js/helpers/common.js"></script><script type="text/javascript"src="http://hr-t4.hr.chengjiukehu.com/assets/js/interface.js"></script><script>Sentry.init({dsn:'https://cef2924e3ee647038d6093af19db7b60@sentry.hr.chengjiukehu.com/12',ignoreErrors:['ResizeObserver loop limit exceeded','ResizeObserver loop completed with undelivered notifications.',R]});var _hmt=_hmt||[];(function(){var hm=document.createElement("script");hm.src="https://hm.baidu.com/hm.js?30ced7282a011b566d12cde0f473158c";var s=document.getElementsByTagName("script")[0];s.parentNode.insertBefore(hm,s)})();</script></head><body><div id="main-container"style="overflow: auto;height: 500px;"><div id="content-container"><div class="redirect"><h1>请根据员工类型进行选择</h1><div class="select-type"><p class="redirect-title">录用流程(通用)<span class="describe">适用于全职员工、全职教师、兼职、在编实习</span></p><a href="http://hr-t4.hr.chengjiukehu.com/hiring/default"class="js-hiring"><p class="redirect-info">录用流程</p></a></div><div class="select-type"><p class="redirect-title">录用流程(教师)<span class="describe">适用于专职教师、兼职教师</span></p><a href="http://hr-t4.hr.chengjiukehu.com/hiring/teacher/zhikang"class="js-hiring"><p class="redirect-info">智康教师录用流程</p></a><!--<a href="http://hr-t4.hr.chengjiukehu.com/hiring/teacher/mobby"class="js-hiring"><p class="redirect-info">摩比教师录用流程</p></a>--></div></div><style type="text/css">a{display:block}h1{font-size:16px;text-align:center;color:#333}.select-type{margin:60px auto;width:70%}.select-type p{text-align:left}.select-type.redirect-title{font-size:16px;margin-bottom:10px}.select-type.redirect-title.describe{font-size:12px;margin-left:7px}.select-type.redirect-info{color:#2C5996;font-size:14px;margin-top:10px}.select-type.redirect-info:before{content:"";display:inline-block;width:10px;height:10px;background-color:#2C5996;border:1px solid#2C5996;border-radius:50%;margin-right:7px}</style><script>$(function(){$('.js-hiring').on('click',function(ev){var data={};var href=$(this).attr('href');$.post(href,data).then(function(response){$('#content-container').html(response)});ev.stopPropagation();return false})})</script></div></div><input type="hidden"name="user_id"value=""/><input type="hidden"name="applied_at"value=""/><input type="hidden"name="name"value=""/><input type="hidden"name="gender"value=""/><input type="hidden"name="birthday"value=""/><input type="hidden"name="email"value=""/><input type="hidden"name="mobile"value=""/><input type="hidden"name="educational"value=""/><input type="hidden"name="id_type"value=""/><input type="hidden"name="id_number"value=""/><input type="hidden"name="job_id"value=""/><input type="hidden"name="job_name"value=""/><input type="hidden"name="elink"value=""/><input type="hidden"name="applicant_id"value=""/><input type="hidden"name="recruit_channel_code"value=""/><input type="hidden"name="recruit_channel_name"value=""/><input type="hidden"name="recruit_type_code"value=""/><input type="hidden"name="recruit_type_name"value=""/><input type="hidden"name="timestamp"value=""/><input type="hidden"name="sign"value=""/><!--公告模板--><script type="text/html"id="notice-message-template"><div class='notice-message-container'><div class="notice-title-container"><h3 class='title'id="notice-message-title"></h3><span class='closeIcon'id='closeIcon'>×</span></div><div class='left-notice-message'><img src='../assets/images/userNotices.png'alt=''></div><div class='right-notice-message'><p id="notice-message-content"></p></div></div></script><script src="http://hr-api-t4.hr.chengjiukehu.com/static/announcement/P03"></script><script>if(location.href.indexOf('.100tal')>-1&&window.bpit_elk_page_start_time){var end_time=(new Date()).getTime();var load_time=end_time-window.bpit_elk_page_start_time;window.bpitCommonDataLog({group:'hrssc',project:'FE-PC-Employee',env:'online',page:'index',time:load_time})}</script></body></html>`;
                    contents = <iframe
                        style={{
                            position: 'absolute',
                            top: '0',
                            left: '0',
                            width: '100%',
                            height:'100vh'
                        }}
                        frameBorder="0"
                        src={this.state.htmlString}></iframe>
                } else {
                    contents = this.renderApplicantHtml()
                }
            }
            else if (this.state.code === "417") {
                contents = this.renderNoPassHtml()
            }
            else {
                contents = <div class="mengniu">
                    <h3>确认有效渠道</h3>
                    <hr />
                    <div class="mengniu-fail">{this.state.message}</div>
                </div>
            }
        }

        return (
            <div class="mengniu-y">{contents}</div>
        );
    }
}
